import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";


import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react'
import TypeAheadLabel from './TypeAheadLabel'

export const TaskTagDropdown = forwardRef(
  (props, ref) => {
    const {command, items, query} = props
    const [selectedIndex, setSelectedIndex] = useState(0)
    const activeRef = useRef(null)
    const selectItem = (idx) => {
      const item = items[idx]
      if (!item) return
      command({id: item.id})
    }

    const upHandler = () => {
      setSelectedIndex((selectedIndex + items.length - 1) % items.length)
    }

    const downHandler = () => {
      setSelectedIndex((selectedIndex + 1) % items.length)
    }

    const enterHandler = () => {
      selectItem(selectedIndex)
    }

    useEffect(() => setSelectedIndex(0), [items])

    useImperativeHandle(ref, () => ({
      onKeyDown: ({event}) => {
        if (event.key === 'ArrowUp') {
          upHandler()
          return true
        }

        if (event.key === 'ArrowDown') {
          downHandler()
          return true
        }

        if (event.key === 'Enter' || event.key === 'Tab') {
          enterHandler()
          return true
        }
        return false
      }
    }))
    if (items.length === 0) return null
    return (
      _jsx('div', { className: "z-10 max-h-56 in-data-[placement=\"bottom-start\"]:animate-slide-down in-data-[placement=\"top-start\"]:animate-slide-up overflow-auto rounded-md border-rad bg-white py-1 shadow-lg outline-hidden"          , children: 
        items.map((item, idx) => {
          const isActive = idx === selectedIndex
          return (
            _jsxs('div', {
              ref: isActive ? activeRef : undefined,
              'data-highlighted': isActive ? '' : undefined,
              className: 
                'flex w-full shrink-0 cursor-pointer items-center rounded-md px-2 py-1 text-slate-700 text-sm leading-8 outline-hidden hover:bg-slate-200! hover:text-slate-900 focus:bg-slate-200 data-highlighted:bg-slate-100 data-highlighted:text-slate-900'
              ,

              onClick: () => selectItem(idx),
 children: [
              _jsx(TypeAheadLabel, {
                label: item.id,
                query: query,
                className: "min-w-20 font-bold" ,
                highlight: true,}
              )
              , _jsx('span', { className: "flex justify-start pl-3"  , children: item.label})
            ]}, item.id)
          )
        })
      })
    )
  }
)
